import { FormControl, FormHelperText, InputLabel, useTheme } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input';

const PhoneNumberInput = ({
  name,
  label,
  control,
  defaultValue,
  helperText,
  disabled,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Controller
      render={({ field: { onChange, onBlur, value } }) => (
        <FormControl fullWidth disabled={disabled} {...props}>
          <MuiTelInput
            variant="outlined"
            size="small"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            defaultCountry={'za'}
            margin="dense"
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                border: '1.5px solid',
                borderColor: theme.palette.text.main,
                borderRadius: '7px'
              },
              '& .MuiInputBase-input': {
                color: theme.palette.text.main
              },
              '& .MuiInputLabel-root': {
                color: theme.palette.text.main
              },
              '&:focus-within .MuiInputLabel-root': {
                color: theme.palette.text.main,
                fontWeight: 'bold'
              }
            }}
          />
          <FormHelperText error={props.error}>{helperText}</FormHelperText>
        </FormControl>
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
};

export default PhoneNumberInput;
